
<template>
  <div class="box__content" :id="`box${uid}`">
    <p :class="{'box__detail--visible': showBoxContent}" class="fontSemiBold box__detail">{{subHeadline}}</p>
    <p v-for="(line, index) in text" :key="index" :class="{'box__detail--visible': showBoxContent}" class="box__text box__detail">{{line}}</p>
    <p v-if="href" class="box__detail" :class="{'box__detail--visible': showBoxContent}">
      <a :href="href" target="_blank">{{linkText}}</a>
    </p>
    <videoEmbed
      v-if="videoUrl"
      class="videoWrapper"
      :class="{'videoWrapper--visible': showBoxContent}"
      v-bind:url=videoUrl>
    </videoEmbed>
    <div class="centerBox">
      <btn
        v-bind:label="this.$props.label"
        v-bind:showLabel="!showBoxContent"
        v-on:click.native="toggleBoxContent(`#box${uid}`)"/>
    </div>
  </div>
</template>


<script>
// https://github.com/rigor789/vue-scrollto
import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import btn from './btn.vue';
import videoEmbed from './videoEmbed.vue';

Vue.use(VueScrollTo);

export default {
  name: 'boxContent',
  components: {
    btn, videoEmbed,
  },
  data() {
    return {
      showBoxContent: false,
      uid: 0,
    };
  },
  props: {
    label: {
      type: String,
      default: () => 'Mehr',
    },
    subHeadline: {
      type: String,
    },
    text: {
      type: Array,
    },
    linkText: {
      type: String,
    },
    href: {
      type: String,
    },
    videoUrl: {
      type: String,
    },
  },
  methods: {
    toggleBoxContent(uid) {
      this.showBoxContent = !this.showBoxContent;
      this.$scrollTo(uid, 500, { offset: -140 });
    },
  },
  mounted() {
    this.uid = Math.floor((Math.random() * 100000) + 1);
  },
};
</script>


<style lang="scss" scoped>
  .box__content {
    opacity: 0;
    transform: translateY(-5rem);
    transition: all 0.5s ease-in-out 0.5s;

    @media #{$mobile} {
      padding: var(--boxPadding);
    }
    @media #{$tablet} {
      padding: var(--boxPadding);
    }
    @media #{$desktop} {
      padding: var(--boxPadding) var(--boxPaddingDesk);
    }
  }
  .box.mounted .box__content {
    opacity: 1;
    transform: translateY(0);
  }
  .box__text {
    text-align: justify;
  }
  .box__detail {
    transition: font-size 0.3s ease 0.3s, opacity 0.3s, margin 0.6s;
    font-size: 0;
    opacity: 0;
    margin: -1.5rem 0 0;
  }
  .box__detail--visible {
    margin: 0 0 1rem;
    opacity: 1;
    transition: font-size 0.3s, opacity 0.3s ease 0.3s, margin 0.3s;

    @media #{$mobile} {
      font-size: 16px;
    }
    @media #{$min-tablet} {
      font-size: 21px;
    }
  }

  .videoWrapper {
    max-height: 0;
    padding: 0;
    overflow: hidden;
    transition: all 0.3s;
  }
  .videoWrapper--visible {
    max-height: 500px;
    padding-bottom: 56.2%;
  }
</style>
